<template>
	<v-form ref="form" v-model="formIsValid" lazy-validation>
		<modal
			:exibir="exibir"
			:titulo="tituloModal"
			:acao-cancelar="fecharModal"
			:custom-actions="false"
			:acao-confirmar="confirmar"
			:is-confirmar-visivel="isConfirmarVisivel"
			:is-confirmar-desabilitado="isConfirmarDesabilitado"
			:tamanho="modalOptions"
			nome-botao-confirmar="Salvar"
			@close="fecharModal"
		>
			<template #body>
				<div class="my-1" :class="{ ajustar_modal_aba_historico: !$vuetify.breakpoint.mobile }">
					<painel-com-tabs-sem-rotas :tabs="tabs" @tab-atual="botaoSalvarNaoDeveAparecerNaAbaHistorico">
						<template #alteracao>
							<alterar-classificacao
								ref="alterar"
								:item-selecionado="itemSelecionado"
								:limite-caracteres-justificativa="limiteCaracteresJustificativa"
								@reset-page="resetarPageAlterarClassificacao"
								@carregar-fornecedores="carregarFornecedores"
							></alterar-classificacao>
						</template>
						<template #historico>
							<historico-alteracao-classificacao
								@reset-page="resetarPageHistoricoAlterarClassificacao"
								@carregar-historico="carregarHistorico"
							></historico-alteracao-classificacao>
						</template>
						<template #acoes-tabs>
							<botao-gerar-pdf-historico
								:id-entidade="itemSelecionado.id"
								:tipo-historico="tipoHistorico.HISTORICO_ALTERACAO_CLASSIFICACAO"
								v-if="!isConfirmarVisivel"
							></botao-gerar-pdf-historico>
						</template>
					</painel-com-tabs-sem-rotas>
				</div>
			</template>
		</modal>
	</v-form>
</template>

<script>
import { TabSemRotaUtils } from '@/core/utils'
import AlterarClassificacao from '@/views/pages/ata/acessar/gestao-da-ata/itens/listagem/alteracao-classificacao/alterar-classificacao/AlterarClassificacao.vue'
import HistoricoAlteracaoClassificacao from '@/views/pages/ata/acessar/gestao-da-ata/itens/listagem/alteracao-classificacao/historico/HistoricoAlteracaoClassificacao.vue'
import { mapState } from 'vuex'
import { actionTypes, getterTypes, mutationTypes } from '@/core/constants'
import validacaoAta from '@/views/mixins/validacaoAta'
import BotaoGerarPdfHistorico from '@/views/components/botoes/gerar-pdf-historico/BotaoGerarPdfHistorico.vue'
import tipoHistorico from '@/core/constants/tipo-historico'

export default {
	name: 'modal-alterar-classificacao',
	components: { BotaoGerarPdfHistorico, AlterarClassificacao, HistoricoAlteracaoClassificacao },
	mixins: [validacaoAta],
	props: {
		exibir: {
			type: Boolean,
		},
	},
	data() {
		return {
			tabs: [
				new TabSemRotaUtils(1, 'Alteração', 'alteracao', () => this.temPermissaoEdicao),
				new TabSemRotaUtils(2, 'Histórico', 'historico', this.existeHistorico),
			],
			tituloModal: 'Alterar Classificação',
			modalOptions: {
				largura: '900',
				altura: '500',
			},
			isConfirmarVisivel: true,
			formIsValid: false,
			limiteCaracteresJustificativa: 300,
		}
	},
	computed: {
		tipoHistorico() {
			return tipoHistorico
		},
		...mapState({
			itemSelecionado: (state) => state.itemAta.itemSelecionado,
			faixaMinClassificacao: (state) => state.itemAta.alterarClassificacao.alterar.faixaMinClassificacao,
			faixaMaxClassificacao: (state) => state.itemAta.alterarClassificacao.alterar.faixaMaxClassificacao,
			datasourceAlterar: (state) => state.itemAta.alterarClassificacao.alterar.datasource,
			paginacaoAlterar: (state) => state.itemAta.alterarClassificacao.alterar.paginacao,
			justificativa: (state) => state.itemAta.alterarClassificacao.alterar.justificativa,
			totalItens: (state) => state.itemAta.alterarClassificacao.alterar.totalElements,
		}),

		isConfirmarDesabilitado() {
			return this.totalItens <= 1 || !this.isJustificativaValida || !this.formIsValid
		},
		isJustificativaValida() {
			return this.justificativa && this.justificativa.length <= this.limiteCaracteresJustificativa
		},
	},
	methods: {
		async confirmar() {
			if (
				this.$refs.form.validate() &&
				!!this.$refs.alterar.$refs.justificativaForm &&
				this.$refs.alterar.$refs.justificativaForm.validate()
			) {
				const classificacoesFaltantes = this.validarClassificacoes()

				if (classificacoesFaltantes.length > 0) {
					this.mostrarNotificacaoErro(`Existem classificações sem preenchimento.`)
					return
				}

				const isClassificacoesAlteradas = this.isClassificacoesAlteradas()

				if (!isClassificacoesAlteradas) {
					this.mostrarNotificacaoErro(`Nenhuma classificação foi alterada para salvar.`)
					return
				}

				await this.alterarFornecedores()
				await this.$refs.alterar.$refs.justificativaForm.reset()
				await this.carregarFornecedores()
				await this.carregarHistorico()
				await this.resetarPaginacaoHistorico()
				await this.mostrarNotificacaoSucessoDefault()
			}
		},
		async alterarFornecedores() {
			await this.$store.commit(
				mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.SET_ALTERACOES_CLASSIFICACAO,
				{
					idItemAta: this.itemSelecionado.id,
					alteracoes: this.datasourceAlterar,
				},
			)
			await this.$store.dispatch(actionTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.ALTERAR_CLASSIFICACAO)
			this.$store.commit(mutationTypes.ITEM_ATA.SET_HISTORICO_ALTERAR_CLASSIFICACAO, true)
		},
		async carregarFornecedores() {
			const { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.BUSCAR_FORNECEDORES,
				this.itemSelecionado.id,
			)

			await this.setDatasourceAlterar(itens, totalElements, totalPages)
		},
		isClassificacoesAlteradas() {
			return this.datasourceAlterar.some((item) => item.classificacao !== item.classificacaoAnterior)
		},
		validarClassificacoes() {
			const classificacoes = new Set(this.datasourceAlterar.map((item) => parseInt(item.classificacao)))

			let classificacoesFaltantes = []

			for (let i = this.faixaMinClassificacao; i <= this.faixaMaxClassificacao; i++) {
				if (!classificacoes.has(i)) {
					classificacoesFaltantes.push(i)
				}
			}

			return this.toStringClassificacoes(classificacoesFaltantes)
		},
		toStringClassificacoes(lista) {
			return lista
				.map((value) => {
					return `${value}\u00B0`
				})
				.toString()
		},
		async setDatasourceAlterar(itens, totalElements, totalPages) {
			this.$store.commit(mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.SET_DATASOURCE, itens)
			this.$store.commit(mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.SET_TOTAL_ELEMENTS, totalElements)
			this.$store.commit(mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.SET_TOTAL_PAGES, totalPages)

			this.$store.commit(
				mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.SET_FAIXA_MIN_CLASSIFICACAO,
				this.getFaixaMinClassificacao(totalElements),
			)
			this.$store.commit(
				mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.SET_FAIXA_MAX_CLASSIFICACAO,
				this.getFaixaMaxClassificacao(itens.length, totalElements),
			)
		},
		async carregarHistorico() {
			const { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.HISTORICO
					.BUSCAR_HISTORICO_ALTERACAO_CLASSIFICACAO_FORNECEDORES,
				this.itemSelecionado.id,
			)

			await this.setDatasourceHistorico(itens, totalElements, totalPages)
		},
		async setDatasourceHistorico(itens, totalElements, totalPages) {
			await this.$store.commit(mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.HISTORICO.SET_DATASOURCE, itens)
			await this.$store.commit(
				mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.HISTORICO.SET_TOTAL_ELEMENTS,
				totalElements,
			)
			await this.$store.commit(mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.HISTORICO.SET_TOTAL_PAGES, totalPages)
		},
		getFaixaMinClassificacao() {
			return (this.paginacaoAlterar.page - 1) * this.paginacaoAlterar.rowsPerPage + 1
		},
		getFaixaMaxClassificacao(totalItensPage) {
			return this.getFaixaMinClassificacao() + totalItensPage - 1
		},
		resetarPaginacaoHistorico() {
			this.$store.commit(mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.HISTORICO.RESETAR_PAGINA_LISTAGEM)
		},
		fecharModal() {
			this.$emit('carregar-listagem-item')
			this.$emit('fechar-modal')
		},
		botaoSalvarNaoDeveAparecerNaAbaHistorico(tabValue) {
			const naoEhHistorico = tabValue !== 1

			if (this.temPermissaoEdicao) {
				this.isConfirmarVisivel = naoEhHistorico
			} else {
				this.isConfirmarVisivel = !naoEhHistorico
			}
		},
		resetarPageAlterarClassificacao() {
			return this.$store.commit(mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.RESETAR_PAGINA_LISTAGEM)
		},
		resetarPageHistoricoAlterarClassificacao() {
			return this.$store.commit(mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.HISTORICO.RESETAR_PAGINA_LISTAGEM)
		},
		existeHistorico() {
			return this.$store.getters[getterTypes.ITEM_ATA.EXISTE_HISTORICO_ALTERAR_CLASSIFICACAO]
		},
	},
}
</script>

<style lang="stylus" scoped>

.ajustar_modal_aba_historico {
	height: 67vh;
}
</style>
